module.exports = __webpack_public_path__ + "img/0Q3A2361_L_WoodMatted_MockedUp.1b860afb.jpg";